// Point d'entrée unique et strict pour l'URL du backend CANAXE
let rawUrl = process.env.REACT_APP_API_URL || '';

// Si l'URL contient /api à la fin, on le retire pour éviter les doublons (on l'ajoute systématiquement dans le code)
// On retire aussi tout slash final inutile.
const API_BASE = rawUrl.replace(/\/api\/?$/, '').replace(/\/$/, '');

if (!API_BASE && !process.env.REACT_APP_API_URL) {
    throw new Error("ERREUR CRITIQUE: La variable d'environnement REACT_APP_API_URL est manquante. L'utilisation de localhost par défaut est strictement bloquée.");
}

export default API_BASE;
